import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start text-xl" }, "Tentativas de check", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-start text-sm text-gray-500 mt-0.5",
  "data-testid": "check-attempts-modal-subtitle"
}

import { computed } from 'vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import CheckAttemptsPanel from '@/components/CheckAttempts/CheckAttemptsPanel.vue'
import {
  EModals,
  useModalStore,
  type checkAttemptsModalDataType
} from '@/pinia-store/useModalStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'check.attempts.modal',
  setup(__props) {

const modalStore = useModalStore()
const isOpen = computed(() => modalStore.modals[EModals.CHECK_ATTEMPTS])
const meta = computed(() =>
  isOpen.value ? (modalStore.metadata as checkAttemptsModalDataType | undefined) : undefined
)

function close() {
  modalStore.toggleModal(EModals.CHECK_ATTEMPTS)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: isOpen.value,
    onClose: close,
    "has-header-border": "",
    maxWidth: "max-w-[1100px]"
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      (meta.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Plantão #" + _toDisplayString(meta.value.stationId) + " · " + _toDisplayString(meta.value.date) + " " + _toDisplayString(meta.value.hours) + " · " + _toDisplayString(meta.value.doctorName) + " · " + _toDisplayString(meta.value.schedule), 1))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (isOpen.value && meta.value)
        ? (_openBlock(), _createBlock(CheckAttemptsPanel, {
            key: meta.value.stationId,
            source: { stationId: meta.value.stationId },
            compact: ""
          }, null, 8, ["source"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})